import { CompetitionPageTemplate } from "@/types/competitions";
import { LandingPageTemplateResponse } from "@/types/landing";
import { OfferPageTemplateResponse } from "@/types/offers";
import { Site } from "@/types/sites";
import { GetServerSidePropsContext, PreviewData } from "next/types";
import { ParsedUrlQuery } from "querystring";

export enum PageType {
    COMPETITION = "competition",
    LANDING = "landing",
    OFFER = "offer",
}

export abstract class PageGeneratorBase<
    T extends
        | CompetitionPageTemplate
        | LandingPageTemplateResponse
        | OfferPageTemplateResponse
> {
    site: Site | null;
    query: ParsedUrlQuery;
    context: GetServerSidePropsContext<ParsedUrlQuery, PreviewData>;
    pageType: PageType;

    constructor(
        pageType: PageType,
        context: GetServerSidePropsContext<ParsedUrlQuery, PreviewData>,
        site: Site | null,
        query: ParsedUrlQuery
    ) {
        this.context = context;
        this.pageType = pageType;
        this.site = site;
        this.query = query;
    }

    abstract isConcerned(): Promise<boolean>;

    abstract load(): Promise<{
        pageType: PageType | null;
        pageData: T | null;
    }>;
}
